<template>
  <div id = "introduction">
    <h1>{{$t('register.introduction.header')}}</h1>
    <button onclick="location.href='https://docs.google.com/forms/d/e/1FAIpQLSd9WJGJJR7j2SxmHezG3-F-TVqUyaAwdqLJiVfInfrOTRvVmg/viewform?usp=sf_link';" type = "button" class = "button">{{$t('register.introduction.join')}}</button>
    <p v-html="introductionText"></p>
  </div>
</template>

<script>
  export default{
    data() {
      return {
        introductionText: this.$t('register.information')
      }
    }
  }
</script>

<style scoped lang="scss">
#introduction {
  @extend %eestec-page;
  padding-bottom: 3vh!important;
}

  div{
    text-align: center;
  }
  p{
    color: black;
  }
  a{
    display:block;
  }
  .button{
    margin-top: 20px;
    margin-bottom: 40px;
    width: auto;
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 0.53em;
    font-size: 35px;
    background-color: $primary-color;
    color: white; 
    outline: none;
    border: none;
    font-weight: bold;
  }
  .button:hover{
    color: white;
    background-color: $secondary-font-color;
  }
  .button:focus{
    color: white;
  }
  .button::-moz-focus-inner {
    border: 0;
  }

  h1 {
    font-size: 32px;
  }
</style>